import { Stack, SxProps, type Theme } from '@mui/material';
import { HXCIcon, Icons } from '../HXCIcon';

export interface CheckboxProps {
  size: 'small' | 'regular';
  type: 'checked' | 'unchecked' | 'disabled';
  surface?: 'default' | 'inverse';
  sx?: SxProps<Theme>;
}

const Checkbox = ({ size, type, surface = 'default', sx }: CheckboxProps) => {
  const isSmall = size === 'small';

  const commonStyles = {
    width: isSmall ? '20px' : '24px',
    minWidth: isSmall ? '20px' : '24px',
    height: isSmall ? '20px' : '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const typeStyles = (theme: Theme) => {
    if (type === 'unchecked') {
      if (surface === 'inverse') {
        return {
          backgroundColor: theme.palette.common.white,
          border: `1px solid ${theme.palette.darkGray.main}`,
        };
      }

      const borderColor = isSmall ? theme.palette.darkGray.main : theme.palette.lightGray.main;
      return {
        border: `1px solid ${borderColor}`,
      };
    }
    if (type === 'checked') {
      return {
        backgroundColor: isSmall ? undefined : theme.palette.white.main,
      };
    }
    return {
      border: `1px solid ${theme.palette.lightGray.main}`,
    };
  };

  const icon =
    type === 'checked' ? (
      <HXCIcon name={Icons.SuccessSm} color="green" sx={sx} />
    ) : type === 'disabled' ? (
      <HXCIcon name={Icons.CrossXs} color="red" scale={1} sx={sx} />
    ) : null;

  return <Stack sx={(theme) => ({ ...commonStyles, ...typeStyles(theme) })}>{icon}</Stack>;
};
export default Checkbox;
